import React, { memo } from 'react'
import Link from 'next/link'
import styles from '@/styles/Home.module.scss'
import { GETDATACAMPAIGNTYPE } from '@/types/Types'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import {
  dialogGroupSpotsState,
  groupSpotsState,
} from '@/features/dialogGroupSpotsSlice'

type StampComponentsType = {
  query: number
  hascount: number
  course: string | string[]
  img: string | null
  name: string
  spots: [
    {
      address: string
      id: number
      name: string
      zip: string
    }
  ]
  dataCampaign: GETDATACAMPAIGNTYPE
}

const StampComponents = memo(
  ({
    query,
    hascount,
    course,
    img,
    name,
    spots,
    dataCampaign,
  }: StampComponentsType) => {
    const router = useRouter()
    const dispatch = useDispatch()

    // const handleSubmit = (
    //   event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    // ) => {
    //   event.preventDefault()
    //   const url = event.currentTarget.href
    //   console.log(url)

    //   gtag.event({
    //     url: url,
    //     action: 'click',
    //     category: 'button',
    //     label: 'spot,notice',
    //   })

    //   return
    // }

    const onGroupModal = () => {
      dispatch(dialogGroupSpotsState(false))
      dispatch(groupSpotsState(spots))
    }

    return (
      <>
        <button
          className={`flex flex-col items-center justify-center ${styles.c_stamp}`}
          onClick={() => {
            spots.length > 1
              ? onGroupModal()
              : router.push({
                  pathname: `/spot/detail/`,
                  query: { query: query, course: course },
                })
          }}
        >
          <div className={styles.c_stamp_img}>
            <img src={img} alt="" />
          </div>
          {dataCampaign.isRepeatStamp && (
            <div className="mt-2 flex min-w-[75px] items-center justify-between break-words break-all rounded-[4px] bg-[#ffc600] px-1 text-xss">
              <p>獲得数:</p>
              <p>{`${hascount >= 100 ? '99+' : hascount}`}</p>
            </div>
          )}

          <p className="mt-1 break-words break-all text-sm">{name}</p>
        </button>
      </>
    )
  }
)

StampComponents.displayName = 'StampComponents'

export default StampComponents
